import { render, staticRenderFns } from "./marquee-text.vue?vue&type=template&id=bd028418&scoped=true&"
import script from "./marquee-text.vue?vue&type=script&lang=js&"
export * from "./marquee-text.vue?vue&type=script&lang=js&"
import style0 from "./marquee-text.vue?vue&type=style&index=0&id=bd028418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd028418",
  null
  
)

export default component.exports